import React, { createContext, useContext, useState, useCallback } from "react";
import translations from "@/i18n/translations";

const LanguageContext = createContext();

export function LanguageProvider({ children }) {
  const [language, setLanguage] = useState("de");

  const t = useCallback(
    (path) => {
      const keys = path.split(".");
      let value = translations[language];
      for (const key of keys) {
        if (value && value[key] !== undefined) {
          value = value[key];
        } else {
          return path;
        }
      }
      return value;
    },
    [language]
  );

  const isRTL = language === "ar";
  const dir = isRTL ? "rtl" : "ltr";

  return (
    <LanguageContext.Provider value={{ language, setLanguage, t, isRTL, dir }}>
      {children}
    </LanguageContext.Provider>
  );
}

export function useLanguage() {
  const context = useContext(LanguageContext);
  if (!context) {
    throw new Error("useLanguage must be used within a LanguageProvider");
  }
  return context;
}
